import { render, staticRenderFns } from "./list-details.vue?vue&type=template&id=51f659da"
import script from "./list-details.vue?vue&type=script&lang=js"
export * from "./list-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports